import {
  GET_UING_FAILED,
  GET_UING_REQUEST,
  GET_UING_SUCCESS,
    GET_UING_CSV_REQUEST,
    GET_UING_CSV_SUCCESS,
    GET_UING_CSV_FAILED
} from "../Actions/UserInfoNGActions";

const initialState = {
    loading: false,
    success: false,
    data: [],
  };


export const UserInfoNGReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_UING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_UING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data:action.payload
      };
    case GET_UING_FAILED:
        return{
            ...state,
            loading:false,
            success:false
        };
    case GET_UING_CSV_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case GET_UING_CSV_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            data:action.payload
        };
    case GET_UING_CSV_FAILED:
        return{
            ...state,
            loading:false,
            success:false
        };
    default:
      return state;
  }
}
export default UserInfoNGReducer;